export default __webpack_public_path__ + "static/media/suite-montanha1-4.cb094c73.jpg";